import React from 'react';

const Colorado = () => {
  return (
    <div>
      
    </div>
  );
}

export default Colorado;
